import SeoText from 'components/Catalog/SeoText/SeoText';

export default SeoText;
